import { MijnRoute } from '../../mijn-navigatie.model';

export const OVERVIEW_ACCOUNTS: MijnRoute = {
    path: 'rekeningen-overzicht',
    navigationEvent: 'toAccountsOverview',
    regex: /^\/rekeningen-overzicht$/,
    webcomponent: 'mijn-overzicht',
    internalPath: '/rekeningen-overzicht'
};
